import { Component, OnInit } from '@angular/core';
import { RequestModel } from 'src/app/models/RequestModel';
import { EncryptDecryptResponse } from 'src/app/models/response/EncryAndDecryResponse';
import { ResponseModel } from 'src/app/models/ResponseModel';
import { BehaviorSubject, Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { EncryptdecryptService } from 'src/app/auth/encryptdecrpt.service';
import { PostmethodService } from 'src/app/app-config/postmethod.service';
import { SharedService } from 'src/app/shared/shared.service';
@Component({
  selector: 'app-mobile-payment',
  templateUrl: './mobile-payment.component.html',
  styleUrls: ['./mobile-payment.component.css']
})
export class MobilePaymentComponent implements OnInit {
  success = false;
  referenceId: any = ''
  responseModel: ResponseModel = new ResponseModel();
  requestModel: RequestModel = new RequestModel();
  encrydecryresponse: EncryptDecryptResponse = new EncryptDecryptResponse();
  isLoading: Subject<boolean> = this.serviceMethod.isLoading;
  public RazorpaysList: any = [];
  imgPath: any = '';
  constructor(private encryptDecrypt: EncryptdecryptService, private sharedservice: SharedService,
    private serviceMethod: PostmethodService) { }

  ngOnInit(): void {
     const data = JSON.parse(sessionStorage.getItem('Razorpay_Payment') || '{}')


    let datass = {
      razorpay_payment_id: data.razorpay_payment_id,
      razorpay_payment_link_id: data.razorpay_payment_link_id,
      razorpay_signature: data.razorpay_signature,
      razorpay_payment_link_reference_id: data.razorpay_payment_link_reference_id,
      razorpay_payment_link_status: data.razorpay_payment_link_status
    }
    this.referenceId = data.razorpay_payment_link_reference_id
    console.log(datass)
    this.requestModel = new RequestModel()
    this.encrydecryresponse = new EncryptDecryptResponse()
    this.encrydecryresponse = this.encryptDecrypt.encryption(datass)
//    console.log("get encrytion:", this.encryptDecrypt.encryption(data));
    this.requestModel.payload = this.encrydecryresponse.data;
    this.sharedservice.getRazorpaysDetails(this.requestModel, this.encrydecryresponse.iv).subscribe((response: any) => {
      this.responseModel = new ResponseModel();
      this.responseModel = response.body;
      let clientSecret = response.headers.get('clientsecret');
      this.encrydecryresponse = this.encryptDecrypt.decryption(this.responseModel.responseData, clientSecret);

      this.responseModel = this.encrydecryresponse.data;

      if(data.razorpay_payment_link_status == "partially_paid" || data.razorpay_payment_link_status == "paid"){
        this.success = true;
      }else{
        this.success = false;
      }
      if (this.responseModel.statusCode == 200) {
       // console.log("Razorpays:", this.responseModel.responseObject.object.updatePaymentInvoiceImagePath[0].imagepath)
       this.imgPath = this.responseModel.responseObject.object.updatePaymentInvoiceImagePath[0].imagepath
        // this.RazorpaysList = this.responseModel.responseObject.object.getRaiseCompliant;

        //this.isLoading = new BehaviorSubject<boolean>(false);
      }
      // else {
      //this.isLoading = new BehaviorSubject<boolean>(false);
      //}

    });

  }

}
